import React, { createContext, useContext, useEffect, useState } from 'react';

const PublicThemeContext = createContext(null);
export const usePublicTheme = () => useContext(PublicThemeContext);

export function PublicThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => (typeof window !== 'undefined' && localStorage.getItem('sila_theme')) || 'light');

  useEffect(() => {
    try { localStorage.setItem('sila_theme', theme); } catch (e) { /* noop */ }
  }, [theme]);

  const toggle = () => setTheme((t) => (t === 'dark' ? 'light' : 'dark'));

  return (
    <PublicThemeContext.Provider value={{ theme, setTheme, toggle }}>
      {children}
    </PublicThemeContext.Provider>
  );
}
